<template>
  <div class="app-container">
    <!-- 用户API搜索部分 -->
    <div class="search-container" style="display: flex; margin-bottom: 20px;">
      <div>
        <el-input v-model="searchForm.userid" placeholder="搜索用户ID" class="search-input" clearable></el-input>
      </div>
      <div style="margin-left: 10px;">
        <el-select v-model="searchForm.isExpired" placeholder="过期状态" clearable>
          <el-option label="全部" :value="null"></el-option>
          <el-option label="已过期" :value="true"></el-option>
          <el-option label="未过期" :value="false"></el-option>
        </el-select>
      </div>
      <div style="margin-left: 10px;">
        <el-button type="primary" @click="fetchUserApis">搜索</el-button>
      </div>
      <div style="margin-left: 10px;">
        <el-button type="success" @click="resetSearch">重置</el-button>
      </div>
    </div>

    <!-- 用户API表格展示 -->
    <el-table :data="userApis" style="width: 100%">
      <el-table-column property="id" label="ID" width="80"></el-table-column>
      <el-table-column property="userid" label="用户ID" width="120"></el-table-column>
      <el-table-column property="apikey" label="API Key" show-overflow-tooltip></el-table-column>
      <el-table-column property="points" label="Points" width="100"></el-table-column>
      <el-table-column property="mail" label="邮箱" show-overflow-tooltip></el-table-column>
      <el-table-column property="expireTime" label="过期时间" width="180">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.expireTime) }}
        </template>
      </el-table-column>
      <el-table-column property="isExpired" label="状态" width="100">
        <template v-slot:default="scope">
          <el-tag :type="scope.row.isExpired ? 'danger' : 'success'">
            {{ scope.row.isExpired ? '已过期' : '有效' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column property="createTime" label="创建时间" width="180">
        <template v-slot:default="scope">
          {{ formatDate(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template v-slot:default="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" style="color: red" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalUserApis">
    </el-pagination>

    <!-- 编辑用户API对话框 -->
    <el-dialog title="编辑用户API" :visible.sync="editDialogVisible" width="40%">
      <el-form :model="currentUserApi" label-width="120px">
        <el-form-item label="用户ID">
          <el-input v-model="currentUserApi.userid" disabled></el-input>
        </el-form-item>
        <el-form-item label="API Key">
          <el-input v-model="currentUserApi.apikey"></el-input>
        </el-form-item>
        <el-form-item label="Points">
          <el-input v-model.number="currentUserApi.points" type="number"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="currentUserApi.mail"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="currentUserApi.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker
              v-model="currentUserApi.expireTime"
              type="datetime"
              placeholder="选择过期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否过期">
          <el-switch v-model="currentUserApi.isExpired"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleUpdate">更新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      searchForm: {
        userid: '',
        isExpired: null
      },
      userApis: [],
      totalUserApis: 0,
      currentPage: 1,
      pageSize: 10,
      editDialogVisible: false,
      currentUserApi: {}
    };
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toLocaleString();
    },

    async fetchUserApis() {
      try {
        const response = await axios.get('/api/admin/user-api/page', {
          params: {
            current: this.currentPage,
            size: this.pageSize,
            userid: this.searchForm.userid || undefined,
            isExpired: this.searchForm.isExpired
          },
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          // 直接使用data数组作为userApis数据
          this.userApis = response.data.data;
          this.totalUserApis = response.data.total;
          this.currentPage = response.data.current;
          this.pageSize = response.data.size;
        } else {
          this.$message.error('获取用户API列表失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('获取用户API列表出错: ' + error.message);
      }
    },

    resetSearch() {
      this.searchForm = {
        userid: '',
        isExpired: null
      };
      this.currentPage = 1;
      this.fetchUserApis();
    },

    handleEdit(userApi) {
      this.currentUserApi = { ...userApi };
      this.editDialogVisible = true;
    },

    async handleUpdate() {
      try {
        const response = await axios.put('/api/admin/user-api', this.currentUserApi, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200) {
          this.$message.success('用户API更新成功');
          this.editDialogVisible = false;
          this.fetchUserApis();
        } else {
          this.$message.error('用户API更新失败: ' + response.data.msg);
        }
      } catch (error) {
        this.$message.error('用户API更新出错: ' + error.message);
      }
    },

    async handleDelete(id) {
      this.$confirm('确定要删除这个用户API吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await axios.delete(`/api/admin/user-api/${id}`, {
            headers: {
              'token': this.$cookies.get('token')
            }
          });

          if (response.data.code === 200) {
            this.$message.success('用户API删除成功');
            this.fetchUserApis();
          } else {
            this.$message.error('用户API删除失败: ' + response.data.msg);
          }
        } catch (error) {
          this.$message.error('用户API删除出错: ' + error.message);
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchUserApis();
    },

    // 添加分配API给用户的方法
    async assignApiToUser() {
      // 这里可以实现分配API给用户的功能
      // 需要先获取可用的API列表，然后选择用户进行分配
      this.$message.info('此功能待实现');
    }
  },
  mounted() {
    this.fetchUserApis();
  }
};
</script>

<style scoped>
.app-container {
  padding: 20px;
}

.search-input {
  width: 200px;
}
</style>
